var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/connections/NotForSale/BarGraphShowcaseUpsell/BarGraphPricePill.jsx";

import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@zillow/constellation';

var BarGraphPricePill = function BarGraphPricePill(_ref) {
  var homePrice = _ref.homePrice;
  return /*#__PURE__*/React.createElement(React.Fragment, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      backgroundColor: '$colors.green100',
      color: '$colors.green500',
      width: '85px',
      borderRadius: '32px',
      textAlign: 'center',
      fontSize: '14px',
      lineHeight: '24px',
      fontWeight: '700',
      fontFamily: 'sans-serif'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7,
      columnNumber: 9
    }
  }, homePrice), /*#__PURE__*/React.createElement(Box, {
    sx: {
      backgroundColor: '$colors.green100',
      width: '12px',
      height: '8px',
      margin: '-8px 0',
      clipPath: 'polygon(100% 0, 50% 50%, 0 0)'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 9
    }
  }));
};

BarGraphPricePill.propTypes = process.env.NODE_ENV !== "production" ? {
  homePrice: PropTypes.string
} : {};
BarGraphPricePill.defaultProps = {
  homePrice: ''
};
export default BarGraphPricePill;